import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { articleCards } from "@/mocks/articles";

const tagBgMap: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-700",
  secondary: "bg-secondary-100 text-secondary-700",
};

export default function ArticleGrid() {
  const navigate = useNavigate();

  const handleClick = (slug: string) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setTimeout(() => navigate(slug), 150);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section id="articles" className="w-full px-6 md:px-10 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4 whitespace-nowrap">
            SEO Resources
          </span>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            Explore Our Sugargoo Spreadsheet Articles
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Dive deep into our collection of original, research-backed guides covering every aspect of the Sugargoo shopping experience.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articleCards.map((article) => (
            <button
              key={article.id}
              onClick={() => handleClick(article.slug)}
              className="group flex flex-col rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-300 overflow-hidden transition-all duration-300 cursor-pointer text-left hover:bg-primary-50/20"
            >
              <div className="relative w-full h-52 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className={`inline-block px-2.5 py-1 rounded-full text-xs font-semibold whitespace-nowrap ${tagBgMap[article.tagColor] || "bg-secondary-100 text-secondary-700"}`}>
                    {article.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="inline-block px-2.5 py-1 rounded-full bg-background-50/90 backdrop-blur-sm text-foreground-600 text-xs font-medium whitespace-nowrap border border-background-200/40">
                    {article.readTime}
                  </span>
                </div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed flex-1">
                  {article.description}
                </p>
                <div className="mt-4 flex items-center gap-2 text-xs font-semibold text-primary-500">
                  <span>Read Article</span>
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}